import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import client from "../lib/api";
import VideoCard from "../components/VideoCard";

export default function Search() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    setLoading(true);
    client.get(`/videos?q=${encodeURIComponent(q)}`)
      .then((r) => setResults(r.data))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="px-4 sm:px-8 lg:px-12 py-10" data-testid="search-page">
      <span className="text-[10px] uppercase tracking-[0.3em] text-[#FFB800]">Search</span>
      <h1 className="text-3xl sm:text-4xl font-bold text-white">Results for "{q}"</h1>
      <p className="mt-1 text-sm text-zinc-500 uppercase tracking-wider">{loading ? "Scanning..." : `${results.length} matches`}</p>
      <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="search-results">
        {results.map((v) => <VideoCard key={v.id} video={v} size="lg" />)}
      </div>
      {!loading && results.length === 0 && q && (
        <p className="mt-10 text-zinc-500 text-center">No transmissions match. Try a different signal.</p>
      )}
    </div>
  );
}
